// extracted by mini-css-extract-plugin
module.exports = {"container":"ProgressLoader_container__24N8o","title":"ProgressLoader_title__2PQPN"};